import { ModalOptions, modalController } from '@ionic/core';
import { TypeKeys } from '.';

export interface GlobalModalShown {
  type: TypeKeys.GLOBAL_MODAL_SHOWN;
  globalModalShown: boolean;
}

export function globalModalShown(globalModalShown: boolean) {
  const action: GlobalModalShown = {
    type: TypeKeys.GLOBAL_MODAL_SHOWN,
    globalModalShown,
  };
  return action;
}

export const showGlobalModal = (
  options: ModalOptions,
  onModalDismiss?: Function
) => async (dispatch, _getState) => {
  dispatch(globalModalShown(true));
  const modalOptions: ModalOptions = {
    ...options,
    componentProps: {
      ...options.componentProps,
    },
  };
  const modal = await modalController.create(modalOptions);
  await modal.present();
  await modal.onDidDismiss();
  dispatch(globalModalShown(false));
  if (onModalDismiss) {
    onModalDismiss();
  }
  console.debug('dismissed');
};
